"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopUserFeedback = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const Card_1 = __importDefault(require("@mui/material/Card"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ImageHeader_1 = __importDefault(require("../ImageHeader"));
const SurveyQuestion_1 = __importDefault(require("../SurveyQuestion"));
const SurveyThankYou_1 = __importDefault(require("../SurveyThankYou"));
const withSnowplowTracking_1 = __importDefault(require("../withSnowplowTracking"));
const FeedbackCopy_1 = __importDefault(require("../../common/FeedbackCopy"));
const Paragraph = styled_components_1.default.p `
  ${({ theme }) => theme.typography.variants.primary.main};
  margin: 0;
  max-width: 497px;
`;
const StyledCard = (0, styled_components_1.default)(Card_1.default) `
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;

  &.MuiPaper-rounded {
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
  }
`;
const ThankYouContainer = styled_components_1.default.div `
  padding: 32px;
`;
const StyledCardContent = styled_components_1.default.div `
  padding: 32px 0 32px 32px;
`;
const LinkContainer = styled_components_1.default.div `
  margin-top: 16px;
`;
const CloseButtonContainer = styled_components_1.default.div `
  margin: 8px 8px 0 0;
`;
const DesktopUserFeedback = ({ isQuestionnaireComplete, lastSubmittedQuestionIndex, onAnswerSubmit, onClose, onGiveFeedbackClick, onSurveyClick, surveyLink, }) => {
    const theme = (0, styled_components_1.useTheme)();
    const [surveyActive, setSurveyActive] = (0, react_1.useState)(false);
    const handleGiveFeedbackClick = () => {
        setSurveyActive(true);
        onGiveFeedbackClick();
    };
    if (isQuestionnaireComplete) {
        return ((0, jsx_runtime_1.jsx)(StyledCard, { children: (0, jsx_runtime_1.jsxs)(ThankYouContainer, { children: [(0, jsx_runtime_1.jsx)(ImageHeader_1.default, { onClose: onClose }), (0, jsx_runtime_1.jsx)(SurveyThankYou_1.default, { handleSurveyClick: onSurveyClick, surveyLink: surveyLink })] }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(StyledCard, { children: [(0, jsx_runtime_1.jsx)(StyledCardContent, { children: !surveyActive ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Paragraph, { "data-testid": "desktop-feedback-prompt", children: FeedbackCopy_1.default.InitialPrompt1 }), (0, jsx_runtime_1.jsx)(Paragraph, { children: FeedbackCopy_1.default.InitialPrompt2 }), (0, jsx_runtime_1.jsx)(LinkContainer, { children: (0, jsx_runtime_1.jsx)(common_buoy_button_1.TextButton, { "data-testid": "give-feedback-button", onClick: handleGiveFeedbackClick, children: FeedbackCopy_1.default.GiveFeedback }) })] })) : ((0, jsx_runtime_1.jsx)(SurveyQuestion_1.default, { lastSubmittedQuestionIndex: lastSubmittedQuestionIndex, onAnswerSubmit: onAnswerSubmit })) }), (0, jsx_runtime_1.jsx)(CloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "close-button", onClick: onClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { color: theme.palette.text.primary, size: 24 }) }) })] }));
};
exports.DesktopUserFeedback = DesktopUserFeedback;
exports.default = (0, withSnowplowTracking_1.default)(exports.DesktopUserFeedback);
//# sourceMappingURL=index.js.map